const sumArrVals = (arrVals) => Array.isArray(arrVals) ? arrVals.reduce((sum, item) => sum + (+item)) : null

export default sumArrVals
